import React from "react";
import general from "../styles/General.module.scss";

const Sonstiges = ({ handleInputChange, inputSummary }) => {
  return (
    <div className={general.inputContainer}>
      <label>Sonstige Informationen</label>
      <textarea
        name="sonstiges"
        onChange={(e) => handleInputChange("sonstiges", e.target.value)}
        value={inputSummary["sonstiges"]}
        className={`${general.largeInput}`}
      />
    </div>
  );
};

export default Sonstiges;
